import type { PropsToProvider } from 'bundles/my-purchases-graphql/data/PageDataProvider';
import type CartsV2 from 'bundles/naptimejs/resources/carts.v2';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import type DegreesV1 from 'bundles/naptimejs/resources/degrees.v1';
import type ProductSkuV1 from 'bundles/naptimejs/resources/productSkus.v1';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import type SubscriptionNextBillDetailsV1 from 'bundles/naptimejs/resources/subscriptionNextBillDetails.v1';
import type SubscriptionsV1 from 'bundles/naptimejs/resources/subscriptions.v1';
import type { OwnableProductByLegacyProductId } from 'bundles/payments-common/hooks/useFindOwnableProducts';
import type { SpecializationType } from 'bundles/payments-common/hooks/useGetSpecializationById';
import { getS12nDisplayNameFromProductVariant } from 'bundles/s12n-common/lib/s12nProductVariantUtils';

export default class PageDataController {
  declare readonly subscriptionId: string;

  declare readonly subscription: SubscriptionsV1;

  declare readonly s12n?: SpecializationType;

  declare readonly mdp?: DegreesV1;

  declare readonly productSku?: ProductSkuV1;

  declare readonly ownableProduct: OwnableProductByLegacyProductId;

  declare readonly subscriptionNextBillDetails?: SubscriptionNextBillDetailsV1;

  declare readonly cart?: CartsV2;

  declare readonly query: Record<string, string>;

  declare readonly s12nProductName: string;

  constructor(data: PropsToProvider) {
    const {
      subscriptionId,
      subscription,
      s12n,
      mdp,
      productSku,
      ownableProduct,
      subscriptionNextBillDetails,
      cart,
      query,
    } = data;

    this.subscriptionId = subscriptionId;
    this.subscription = subscription;
    this.s12n = s12n;
    this.mdp = mdp;
    this.productSku = productSku;
    this.ownableProduct = ownableProduct;
    this.subscriptionNextBillDetails = subscriptionNextBillDetails;
    this.cart = cart;
    this.query = query;

    if (!s12n) {
      this.s12nProductName = '';
    } else {
      this.s12nProductName = getS12nDisplayNameFromProductVariant(s12n.name, s12n.productVariant);
    }
  }
}
